import { call, put, takeLatest } from "redux-saga/effects";
import { authenticationApi } from "../../../../services/apis/userApis";
import { setToken } from "../../../../utils";
import { actionCreator } from "../../../../store/utils";
import { LOG_IN_USER,LOG_OUT_USER } from "./types";
import { CONST_ACCESS_TOKEN, CONST_REFRESH_TOKEN, } from "../../../../utils/const";
import jwt_decode from 'jwt-decode';
import { showToast } from "../../../../components/commun/Toaster/resources/actions";


function* authentication({ credentials }: { credentials: any }): Generator<any, any, any> {
  try {
    credentials['grant_type'] = 'password';
    // Call keycloak authentication API
    const authCredentials = yield call(authenticationApi, credentials);
    const decodedToken: any = jwt_decode(authCredentials.access_token);

    if (!authCredentials) {
      yield put({ type: actionCreator("fail", LOG_IN_USER) });
      yield put(showToast({ message: "Probème d'authentification, merci de contacter votre administrateur", type: "error" }));
    }
    else if (!((decodedToken?.realm_access?.roles?.includes('admin') || decodedToken?.realm_access?.roles?.includes('agent'))  ?? false)) {
      yield put(showToast({ message: "Vous n'avez pas le rôle correspondant pour accéder", type: "error" }));
    }
    else {
      setToken(CONST_ACCESS_TOKEN, authCredentials.access_token);
      setToken(CONST_REFRESH_TOKEN, authCredentials.refresh_token);
      yield put({
        type: actionCreator("res", LOG_IN_USER), data: {
          userName: decodedToken?.preferred_username
        }
      });
    }
  } catch (error: any) {


  }
}
function* logout() {
  try {
    // Call keycloak logout API
    yield put({ type: actionCreator("res", LOG_OUT_USER) });
  } catch (error: any) {
    yield put({ type: actionCreator("fail", LOG_OUT_USER) });
  }
}
export function* watchLogout() {
  yield takeLatest<any>(actionCreator("req", LOG_OUT_USER), logout)
}


export function* watchAuthentication() {
  yield takeLatest<any>(actionCreator("req", LOG_IN_USER), authentication)
}
